module.exports = __webpack_public_path__ + "static/logo_white-ec4025951b1460adc590d3018f439089.png";